import React from 'react';
import { FaInfoCircle } from 'react-icons/fa';

const OnOffSwitch = (props: {
  checked?: boolean;
  label?: string;
  name: string;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement> & {
      target: HTMLInputElement;
    }
  ) => void;
  helperText?: string;
  disabled?: boolean;
}) => {
  const { checked, label, name, onChange, helperText, disabled } = props;

  return (
    <div
      className={`d-flex ${disabled ? 'disabled-switch' : ''}`}
      style={{ pointerEvents: disabled ? 'none' : 'auto' }}
    >
      <input
        checked={checked}
        onChange={onChange}
        className="react-switch-checkbox"
        id={name}
        name={name}
        type="checkbox"
        disabled={disabled}
      />
      <label
        className={`react-switch-label ${disabled ? 'disabled' : ''}`}
        htmlFor={name}
        style={{
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.5 : 1,
          filter: disabled ? 'grayscale(0.5)' : 'none',
        }}
      >
        <span
          className={`react-switch-button ${disabled ? 'disabled' : ''}`}
          style={{
            opacity: disabled ? 0.6 : 1,
          }}
        />
      </label>
      <label
        className={`ms-2 ${disabled ? 'text-muted' : ''}`}
        style={{
          cursor: disabled ? 'not-allowed' : 'default',
          opacity: disabled ? 0.6 : 1,
        }}
      >
        {label}
      </label>
      {!!helperText && (
        <p
          className="mb-0"
          style={{
            opacity: disabled ? 0.6 : 1,
          }}
        >
          <small className="d-flex align-items-center">
            <FaInfoCircle
              className={`${disabled ? 'text-muted' : 'text-secondary'} me-2`}
            />
            {helperText}
          </small>
        </p>
      )}
    </div>
  );
};

export default OnOffSwitch;
